import './Header.css';

export default function Header() {
  return (
    <header className='header'>
      <h1 className='header__text'>
        <strong>Job</strong> Search
      </h1>
    </header>
  );
}
